export default "69131442c770534d.svg"